export interface IFamilyMoveServiceCarState {
    carInfoList: Array<{
        idx: number;
        size: string;
        type: string;
        etc: string;
        count: number;
    }>;
    carInfoValid?: boolean;
}

export type TFamilyMoveCarInfoAction =
    | { type: 'CREATE'; }
    | { type: 'DELETE'; idx: number }
    | { type: 'MODIFY'; carInfo: { idx: number, size: string, type: string, etc: string, count: number } };

export const defaultState: IFamilyMoveServiceCarState = {
    carInfoList: [{ idx: 0, size: '', type: '', etc: '', count: 1 }],
};

export interface IServiceFamilyMoveReducer {
    (state: IFamilyMoveServiceCarState, action: TFamilyMoveCarInfoAction): IFamilyMoveServiceCarState;
}

export default function serviceFamilyMoveReducer(state: IFamilyMoveServiceCarState, action: TFamilyMoveCarInfoAction): IFamilyMoveServiceCarState {
    switch (action.type) {
        case 'CREATE':
            const idx = Math.max(...state.carInfoList.map(item => item.idx)) + 1;
            state = { ...state, carInfoList: state.carInfoList.concat({ idx: idx, size: '', type: '', etc: '', count: 1 }) }
            break;
        case 'DELETE':
            state = { ...state, carInfoList: state.carInfoList.filter(item => item.idx !== action.idx) };
            break;
        case 'MODIFY':
            state = {
                ...state, carInfoList: state.carInfoList.map(item => (item.idx === action.carInfo.idx ?
                    {
                        ...item,
                        size: action.carInfo.size,
                        type: action.carInfo.type,
                        etc: action.carInfo.etc,
                        count: action.carInfo.count
                    }
                    : item))
            }
            break;
        default:
            state = defaultState;
            break;
    }

    state = {
        ...state,
        carInfoValid: state.carInfoList.every((item) => {
            return item.size !== '' && item.type !== '';
        })
    }

    return state;
}
